module.exports = "<bustypes-page></bustypes-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/bustypes.html
// module id = 1423
// module chunks = 0